/**
 * Configuration des trois boîtes de réception Entreprise (Files PMS) — Batch #14.314.
 */
import { Car, Receipt, TrendingUp } from "lucide-react";
import { fmtCAD } from "@/lib/format";

export const ENT_KINDS = {
  revenues: {
    tab: "ent_revenues", countKey: "ent_revenues_pending", label: "Factures de revenus", tone: "emerald", icon: TrendingUp, text: "text-emerald-700", headBg: "bg-emerald-50/60",
    title: "Entreprise — factures de revenus reçues du portail",
    hint: "Le client déclare une facture / un revenu depuis son portail. Saisissez la vente dans Tenue de livres › Transactions clients, puis marquez la pièce traitée.",
    amount: (it) => it.total, fmtTotal: fmtCAD, booksLabel: "Ventes du dossier",
    booksLink: (m) => `/admin/tenue-livres/${m}/transactions-clients?tab=ventes`,
    primary: (it) => it.customer || it.description || "Revenu", secondary: (it) => [it.description && it.customer ? it.description : null, it.payment_method].filter(Boolean).join(" · "),
  },
  expenses: {
    tab: "ent_expenses", countKey: "ent_expenses_pending", label: "Dépenses & reçus", tone: "rose", icon: Receipt, text: "text-rose-700", headBg: "bg-rose-50/60",
    title: "Entreprise — dépenses et reçus reçus du portail",
    hint: "Le client photographie son reçu depuis son portail. Saisissez l'achat dans Tenue de livres › Transactions fournisseurs, puis marquez la pièce traitée.",
    amount: (it) => it.total, fmtTotal: fmtCAD, booksLabel: "Achats du dossier",
    booksLink: (m) => `/admin/tenue-livres/${m}/transactions-fournisseurs?tab=achats`,
    primary: (it) => it.vendor || it.description || it.category || "Dépense", secondary: (it) => [it.category, it.description && it.vendor ? it.description : null, it.business_pct < 100 ? `${it.business_pct} % affaires` : null].filter(Boolean).join(" · "),
  },
  mileage: {
    tab: "ent_mileage", countKey: "ent_mileage_pending", label: "Kilométrage", tone: "amber", icon: Car, text: "text-amber-700", headBg: "bg-amber-50/60",
    title: "Entreprise — trajets kilométrage reçus du portail",
    hint: "Trajets d'affaires déclarés par le client. Le total annuel et le taux $/km sont repris dans Aperçu entreprise.",
    amount: (it) => it.km_distance, fmtTotal: (v) => `${Number(v || 0).toLocaleString("fr-CA", { maximumFractionDigits: 1 })} km`, booksLabel: "Aperçu entreprise",
    booksLink: (m) => `/admin/tenue-livres/${m}/apercu`,
    primary: (it) => `${it.from_location} → ${it.to_location}`, secondary: (it) => it.purpose || "",
  },
};

export const ENT_TABS = Object.values(ENT_KINDS).map((k) => ({ id: k.tab, label: k.label, icon: k.icon, tone: k.tone, countKey: k.countKey }));
export const ENT_TAB_KIND = Object.fromEntries(Object.entries(ENT_KINDS).map(([kind, k]) => [k.tab, kind]));
